<template>
  <div>
    <v-card tile>
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{ title_hu }}</h3>
      </v-card-title>
      <v-card-text>
        <v-spacer />
        {{ action_hint_hu }}
      </v-card-text>
      <v-card-title>
        <v-textarea readonly :label="result_placeholder_hu" :value="result" rows="25" max-rows="50">
        </v-textarea>
      </v-card-title>
    </v-card>
  </div>
</template>
<script>
import ApiService from '@/services/ApiService';
import mapboxgl from 'mapbox-gl';

export default {
  name: 'RevGeocode',
  props: ['map'],
  data() {
    return {
      title: 'Reverse Geocode',
      title_hu: 'Keresés koordinátákkal',
      action_hint: 'Click on the map to see the result',
      action_hint_hu: 'A koordináta-alapú kereséshez egyszerűen kattints a térképre',
      hint: 'Search places by coordinates',
      hint_hu: 'Keresés koordinátákkal',
      result: '',
      result_placeholder: 'Reverse Geocode result:',
      result_placeholder_hu: 'Koordinátákkal keresés eredménye',
      response_msg: 'Unknown error',
      response_msg_hu: 'Ismeretlen hiba',
      marker: undefined
    };
  },
  mounted() {
    this.map.on('click', this.mapClick);
    this.map.getCanvas().style.cursor = 'pointer';
  },
  beforeDestroy() {
    this.map.off('click', this.mapClick);
    this.map.getCanvas().style.cursor = '';
    this.deleteMarker();
  },
  methods: {
    revGeocode(lng, lat) {
      ApiService.revGeocode(lng, lat)
        .then((response) => {
          this.result = JSON.stringify(response.data.result.features, null, 4);
        })
        .catch((e) => {
          this.$swal(
            JSON.stringify(
              e.response.data && e.response.data.meta && e.response.data.meta.message
                ? e.response.data.meta.message
                : this.$data.response_msg_hu
            )
          );
        });
    },
    deleteMarker() {
      if (this.marker) {
        this.marker.remove();
        this.marker = undefined;
      }
    },
    mapClick(e) {
      this.deleteMarker();
      this.marker = new mapboxgl.Marker().setLngLat([e.lngLat.lng, e.lngLat.lat]).addTo(this.map);
      this.revGeocode(e.lngLat.lng, e.lngLat.lat);
    }
  }
};
</script>
